module.exports = __webpack_public_path__ + "static/media/036-customer-service.c238431d.png";